import React, { useState, useRef, useEffect } from 'react';
import { useStyles } from '@webapps/styles';

const DropdownCrud = ({
  label,
  placeholder,
  itemLabel = "élément",
  suggestions = [],
  addButtonLabel = "Ajouter",
  dataTransform,
  handleCreate,
  handleDelete,
  value,
  onChange,
  isCreateLoading = false,
  isDeleteLoading = false,
  deletingItemId = null
}) => {
  const {
    global,
    cx,
    theme: { spacing },
    classes,
    css,
  } = useStyles(styles);

  console.log("dataTransform:", `${addButtonLabel} : `, dataTransform);

  const [selectedValue, setSelectedValue] = useState(value || '');
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [availableOptions, setAvailableOptions] = useState(suggestions || []);

  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // Synchroniser l'état local avec les props suggestions
  useEffect(() => {
    setAvailableOptions(suggestions || []);
  }, [suggestions]);

  // Synchroniser avec la prop value
  useEffect(() => {
    if (value !== selectedValue) {
      setSelectedValue(value || '');
      setInputValue(dataTransform && value ? dataTransform(value) : value?.label || '');
    }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const clearSelection = () => {
    setSelectedValue('');
    setInputValue('');
    if (inputRef.current) inputRef.current.focus();
  };

  const selectOption = (option) => {
    setSelectedValue(option);
    setInputValue(dataTransform ? dataTransform(option) : option?.label || '');
    setIsOpen(false);
    onChange && onChange(option);
  };

  const deleteOption = (optionToDelete) => {
    setAvailableOptions(prev => prev.filter(option => option !== optionToDelete));
    if (selectedValue === optionToDelete) {
      setSelectedValue('');
      setInputValue('');
    }
    console.log('Suppression de:', optionToDelete);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setIsOpen(true);
    if (value !== selectedValue) setSelectedValue('');
  };



  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const inputStr = String(inputValue || '').toLowerCase();
      const exactMatch = filteredOptions.find(option => {
        const optionStr = dataTransform ? String(dataTransform(option) || '').toLowerCase() : String(option?.label || '').toLowerCase();
        return optionStr === inputStr;
      });
      if (exactMatch) {
        selectOption(exactMatch);
      } else if (filteredOptions.length > 0) {
        selectOption(filteredOptions[0]);
      } else if (inputValue && String(inputValue).trim()) {
        handleCreate && handleCreate(String(inputValue).trim());
      }
    }
  };

  const filteredOptions = availableOptions.filter(option => {
    const inputStr = String(inputValue || '').toLowerCase();
    const optionStr = dataTransform ? String(dataTransform(option) || '').toLowerCase() : String(option?.label || '').toLowerCase();
    return optionStr.includes(inputStr);
  });

  return (
    <div className={classes.container}>
      <div ref={dropdownRef} style={{ position: 'relative' }}>
        <div className={classes.inputContainer}>
          <input
            ref={inputRef}
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            onFocus={() => setIsOpen(true)}
            placeholder="Ajouter ou sélectionner..."
            className={classes.input}
          />
          <div className={classes.inputIcons}>
            {selectedValue && (
              <button
                onClick={clearSelection}
                title="Effacer la sélection"
                className={classes.iconColor}
              >
                <svg className={classes.iconSmall} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
            <button onClick={() => setIsOpen(!isOpen)} className={classes.iconColor}>
              <svg className={cx(classes.iconSmall, { [classes.rotateIcon]: isOpen })} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>
        </div>

        {isOpen && (
          <div className={classes.dropdownMenu}>

            <div className={classes.dropdownHeader}>
              <button
                onClick={() => handleCreate && handleCreate(String(inputValue).trim())}
                className={classes.addButton}
                disabled={isCreateLoading}
              >
                {isCreateLoading ? (
                  <svg className={classes.iconSmall} fill="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="3" opacity="0.3">
                      <animate attributeName="opacity" values="0.3;1;0.3" dur="1s" repeatCount="indefinite" />
                    </circle>
                  </svg>
                ) : (
                  <svg className={classes.iconSmall} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                )}
                {isCreateLoading ? 'Ajout en cours...' : `${addButtonLabel} "${inputValue}"`}
              </button>
            </div>

            <div>
              {filteredOptions.length === 0 && !inputValue.trim() ? (
                <div className={classes.noOption}>Aucune option disponible</div>
              ) : filteredOptions.length === 0 ? (
                <div className={classes.noOption}>Aucune option trouvée</div>
              ) : (
                filteredOptions.map((option, index) => (
                  <div
                    key={index}
                    className={classes.optionRow}
                    style={selectedValue === option ? styles.optionSelected : styles.option}
                  >
                    <span onClick={() => selectOption(option)} className={classes.optionText}>{dataTransform ? dataTransform(option) : option?.label}</span>
                    <div className={classes.optionActions}>
                      {selectedValue === option && (
                        <svg className={classes.iconSmall} fill="none" stroke="#152652" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      )}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          if (window.confirm(`Êtes-vous sûr de vouloir supprimer "${dataTransform ? dataTransform(option) : option?.label}" ?`)) {
                            handleDelete && handleDelete(option?.id);
                          }
                        }}
                        className={classes.deleteButtonIcon}
                        title="Supprimer cette option"
                        disabled={isDeleteLoading && deletingItemId === option?.id}
                      >
                        {isDeleteLoading && deletingItemId === option?.id ? (
                          <svg className={classes.iconTiny} fill="currentColor" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="3" opacity="0.3">
                              <animate attributeName="opacity" values="0.3;1;0.3" dur="1s" repeatCount="indefinite" />
                            </circle>
                          </svg>
                        ) : (
                          <svg className={classes.iconTiny} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        )}
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

const styles = () => ({
  container: { fontFamily: 'Roboto, sans-serif' },
  inputContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  input: {
    fontSize: '13.5px', color: '#152652', backgroundColor: '#F3F7FF', border: '1px solid #C0D9FF',
    padding: '6px 40px 6px 8px', borderRadius: '10px', outline: 'none', width: '100%',
    height: '40px',
    '&::placeholder': {
      color: "#5D75A8"
    }
  },
  inputIcons: {
    position: 'absolute',
    right: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  iconColor: { color: '#152652', background: 'none', border: 'none', cursor: 'pointer' },
  iconSmall: { width: '16px', height: '16px' },
  iconTiny: { width: '12px', height: '12px' },
  rotateIcon: { transform: 'rotate(180deg)', transition: 'transform 0.2s ease' },
  dropdownMenu: {
    position: 'absolute',
    zIndex: 1000,
    backgroundColor: '#ffffff',
    border: '1px solid #C0D9FF',
    borderRadius: '4px',
    marginTop: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    width: '100%',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
  },
  dropdownHeader: { padding: '8px', borderBottom: '1px solid #C0D9FF' },
  addButton: {
    fontSize: '13.5px', color: '#152652', backgroundColor: '#E8F2FF',
    fontFamily: 'Roboto, sans-serif', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', border: 'none', cursor: 'pointer', borderRadius: '4px'
  },
  option: { fontSize: '13.5px', color: '#152652', fontFamily: 'Roboto, sans-serif', backgroundColor: 'white' },
  optionSelected: { fontSize: '13.5px', color: '#152652', fontFamily: 'Roboto, sans-serif', backgroundColor: '#E8F2FF' },
  noOption: { fontSize: '13.5px', color: '#152652', opacity: 0.6, fontFamily: 'Roboto, sans-serif', padding: '8px' },
  optionRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', cursor: 'pointer' },
  optionText: { flex: 1 },
  optionActions: { display: 'flex', alignItems: 'center', gap: '4px' },
  deleteButtonIcon: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#e11d48',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed'
    }
  },
  testSection: { backgroundColor: '#F3F7FF', border: '1px solid #C0D9FF', padding: '12px', marginTop: '16px' },
  testTitle: { fontSize: '13.5px', color: '#152652', marginBottom: '4px' },
  testValue: { fontSize: '13.5px', color: '#152652', opacity: 0.8 },
  testOptions: { fontSize: '12px', color: '#152652', opacity: 0.7 }
});

export default DropdownCrud;
